// extracted by mini-css-extract-plugin
export default {"textTruncate":"TextTruncate_textTruncate__pdj0o","textTruncateSeeMore":"TextTruncate_textTruncateSeeMore__X7ojC"};